export function GearIcon(props: { size?: number }) {
  const size = props.size ?? 22;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-hidden="true"
    >
      <path
        d="M12 8a4 4 0 1 0 0 8 4 4 0 0 0 0-8Zm8.94 3.5-.98-.56a7.97 7.97 0 0 0-.67-1.61l.5-1.06a1 1 0 0 0-.37-1.29l-1.5-1a1 1 0 0 0-1.3.2l-.8.9c-.52-.27-1.07-.49-1.65-.64L13.5 3h-3l-.67 1.94c-.58.15-1.13.37-1.65.64l-.8-.9a1 1 0 0 0-1.3-.2l-1.5 1a1 1 0 0 0-.37 1.29l.5 1.06c-.26.52-.48 1.06-.66 1.61l-.99.56a1 1 0 0 0-.5 1.06l.25 1.8a1 1 0 0 0 .86.85l1.13.16c.17.55.39 1.08.66 1.59l-.63.96a1 1 0 0 0 .13 1.25l1.28 1.28a1 1 0 0 0 1.25.13l.96-.63c.5.27 1.03.49 1.59.66l.16 1.13a1 1 0 0 0 .85.86l1.8.26a1 1 0 0 0 1.06-.5l.56-.98c.55-.18 1.09-.4 1.61-.66l1.06.5a1 1 0 0 0 1.29-.37l1-1.5a1 1 0 0 0-.2-1.3l-.9-.8c.27-.52.49-1.07.64-1.65l1.94-.67v-3l-1.94-.67Z"
        stroke="currentColor"
        strokeWidth="1.5"
        fill="none"
      />
    </svg>
  );
}

